import { Component, OnInit } from '@angular/core';
import { DataService } from './../data.service';
import { HelperService } from './../helper.service';
import { Subscription, interval } from 'rxjs';

@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit {

    constructor(
        public dataService: DataService,
        public helperService: HelperService
    ) { }

    private subscription: Subscription;
    public localRacers: any = [];
    public countdown: string = "";

    ngOnInit(): void {
        if (this.dataService.racers.length == 0){
            this.dataService.getAllRacers();
        }
        let scope = this;
        this.subscription = interval(800) // testing 500, 1000 is the original 1 second loop
            .subscribe(x => {
                this.processRacers();
                if (!scope.dataService.raceStarted) {
                    scope.countdownGenerate(scope.dataService.raceProfiles.backyard2023.startTime);
                }
            });
        // this occurs within the dataservice
        // this.subscription = interval(5 * 60 * 1000) // 5 minutes to refresh
        //     .subscribe(y => {
        //         scope.dataService.getAllRacers();
        //         console.log("refresh racers !!");
        //     })
        // console.log(this.dataService.lapTimeRemainingMS())
    }
    public countdownGenerate(date){
        this.countdown = this.helperService.friendlyTimeDuration( Date.parse(date) - Date.parse(new Date().toISOString()), "ms");
    }

    public lastLap(racer){
        // determine the current race lap
        if (racer.laps[racer.laps.length - 1].completed){
            if (racer.laps[racer.laps.length - 1].lap > this.dataService.raceProfiles.backyard2023.lapCounter){
                // console.log(racer.laps[racer.laps.length - 1]);
                return this.helperService.friendlyTimeDuration(racer.laps[racer.laps.length - 1].lapDuration, 'ms');
            } else {
                // console.log(this.helperService.friendlyTimeDuration(this.dataService.raceProfiles.backyard2022.lapIncrementDuration-this.dataService.lapTimeRemainingMS(), 'ms'));
                return this.helperService.friendlyTimeDuration(this.dataService.raceProfiles.backyard2023.lapIncrementDuration-this.dataService.lapTimeRemainingMS(), 'ms');
            }
        } else {
            // console.log(this.helperService.friendlyTimeDuration(this.dataService.raceProfiles.backyard2022.lapIncrementDuration-this.dataService.lapTimeRemainingMS(), 'ms'));
            return this.helperService.friendlyTimeDuration(this.dataService.raceProfiles.backyard2023.lapIncrementDuration-this.dataService.lapTimeRemainingMS(), 'ms');
        }
    }

  // the following & distance & elevation could be handled with a loop through the racer objects and updated there.
    private processRacers(){
        this.localRacers = [];
        let now = new Date();
        let raceTimeElapsedMS = Date.parse(now.toISOString()) - Date.parse(this.dataService.raceProfiles.backyard2023.startTime);
        let raceLap = Math.floor(raceTimeElapsedMS / this.dataService.raceProfiles.backyard2023.lapIncrementDuration) + 1;
        for (let r = 0; r < this.dataService.racers.length; r++){
            if (this.dataService.racers[r]["backyard2023"]) {
                let lapCount = 0;
                let currentPosition = "Not Started";
                let racer = this.dataService.racers[r];
                let racerTimeMS = 0;
                for (let l = 0; l < this.dataService.racers[r].laps.length; l++) {
                    if (this.dataService.racers[r].laps[l].started && this.dataService.racers[r].laps[l].completed) {
                        lapCount++;
                        racerTimeMS += this.dataService.racers[r].laps[l].lapDuration;
                        currentPosition = "In Pits"
                    } else if (raceLap == racer.laps[l].lap) {
                        // console.log(this.dataService.raceProfiles.backyard2022.lapIncrementDuration+" - "+this.dataService.lapTimeRemainingMS());
                        racerTimeMS += ((60 * 60 * 1000) - this.dataService.lapTimeRemainingMS());
                        currentPosition = "On Course";
                    } else {
                        if (lapCount > 0 && raceLap > this.dataService.racers[r].laps.length) {
                            currentPosition = "Finished";
                        } else if (raceLap > 0 && this.dataService.racers[r].laps[0].started && !this.dataService.racers[r].laps[0].completed) {
                            currentPosition = "Finished";
                        }
                    }
                }
                racer.currentPosition = currentPosition;

                if (lapCount > 0 || currentPosition == "On Course" || currentPosition == "Finished") {

                    racer.lapCount = lapCount;
                    racer.distance = parseFloat((racer.lapCount * this.dataService.raceProfiles.backyard2023.lapDistance).toFixed(3));
                    racer.elevation = parseFloat((racer.lapCount * this.dataService.raceProfiles.backyard2023.lapElevation).toFixed(3));
                    racer.timeOnCourse = racerTimeMS;
                    this.localRacers.push(racer);
                }

                if (currentPosition == "Not Started") {
                    this.localRacers.push(racer);
                }
            }
        }

        this.localRacers.sort(function(a, b){
            if (!a.laps[0]){
                return 1;
            } else if (!b.laps[0]) {
                return -1;
            }
            if (a.lapCount == b.lapCount){
                return a.timeOnCourse - b.timeOnCourse;
            } else {
                return b.lapCount - a.lapCount;
            }
        })
    }


  // will need to ensure racers are in order of total time on course

}
